// Portfolio, overview, and reporting components
import { defineAsyncComponent } from 'vue'

export default {
  Benchmarking: defineAsyncComponent(() => import('../benchmarking/main.vue')),
  OverviewMap: defineAsyncComponent(() => import('../overview_map/index.vue')),
  OverviewPowerPlantList: defineAsyncComponent(
    () => import('../overview/index.vue')
  ),
  PortfolioStatsIndex: defineAsyncComponent(
    () => import('../portfolio_stats/index.vue')
  )
}
